import BaseMoney from 'presentation/components/BaseMoney/BaseMoney.vue';
import BaseDate from 'presentation/components/BaseDate/BaseDate.vue';
import Spinner from 'presentation/components/Spinner/Spinner.vue';
import Pagination from 'presentation/components/Pagination/Pagination.vue';
import { useI18n } from 'vue-i18n';
// import { computed } from 'vue';
// import {fetchWithToken} from '../../../../apollo/auth';
// import { useRoute, useRouter } from 'vue-router';
import Modal from 'presentation/components/Modal/Modal.vue';
// import usePaging from 'hooks/usePaging';
import useCustomerTools, { isSeller } from 'hooks/useCustomerTools';
import { computed } from 'vue';

// import useMyQuotes from 'hooks/useMyQuotes';

// import dummy from "./dummy";
export default {
    setup(){
        const tools = useCustomerTools();
        const { setPage, loading, quotes, total, page, deleteQuoteRequest, cancelQuoteRequest } =
        tools.useMyQuotes();
        const { t } = useI18n();
        const quoteListNotEmpty = computed(() => {
            return Boolean(quotes.value.length);
          });
        const isSellerUser =  isSeller();
        return {
            t, 
            setPage,
            page,
            loading,
            quoteData: quotes,
            total,
            quoteListNotEmpty,
            deleteQuoteRequest,
            cancelQuoteRequest,
            isSellerUser
        }
    },
    components: {
        BaseMoney,
        BaseDate,
        Spinner,
        Pagination,
        Modal
    },
    data: () => ({
        isModalVisible: false,
        selectedQuote: null,
        modalType: null
        
    }),
    methods: {
        showModal(type, data){
            this.isModalVisible = true;
            this.selectedQuote = data.quote;
            this.modalType = type;
        },
        hideModal(){
            this.isModalVisible = false;
            this.selectedQuote = null;
            this.modalType = null;
        },
        submitCancelRequest() {
            this.cancelQuoteRequest(this.selectedQuote).then((resp)=> {
                if(resp) {
                    this.hideModal();
                }
            });
        },
        submitDeleteRequest() {
            this.deleteQuoteRequest(this.selectedQuote).then((resp)=> {
                if(resp) {
                    this.hideModal();
                }
            })
        }
    }
}